 var acc_btn = document.querySelectorAll(".accordion-main .accordion-summry");
 acc_btn.forEach(function(single){
    single.addEventListener('click', function(){
        if(single.parentElement.hasAttribute("open")){
             single.parentElement.removeAttribute("open");
        }
        else {
             single.parentElement.setAttribute("open","");
        }
       
    })
});

var dropdwon_btn = document.querySelectorAll('.dropdown_custom');

dropdwon_btn.forEach(function(single){
    single.querySelector('.dropdown_btn').addEventListener('click', function(){
        if(single.hasAttribute("open")){
             single.removeAttribute("open");
        }
        else {          
          single.setAttribute("open","");        
        }       
    })
});

 if (window.matchMedia("(min-width: 992px)").matches){
  var pro_det = document.querySelectorAll('.pro-sug-details');
  var get_height = 0;
  pro_det.forEach(function(single){
     if(get_height < single.offsetHeight ) {
          get_height = single.offsetHeight;
     } 
  })
  pro_det.forEach(function(single){
      single.style.height = get_height+"px";
  })
 }


